import React from 'react';
import {UeThemeProvider, useProperLightTheme, useProperDarkTheme} from 'epic-ue-theme';

export type ThemeOverrideOptions = 'light' | 'dark' | 'inherit';

export interface ThemeOverrideProps {
    theme?: ThemeOverrideOptions;
    children?: React.ReactNode;
}

/**
 * This component will wrap the children components in a new ThemeProvider if
 * a value for `theme` is provided that does not match the value `inherit`.
 *
 */
export const ThemeOverrideWrapper = (props: ThemeOverrideProps): JSX.Element | null => {
    const {theme, children} = props;
    const properLightTheme = useProperLightTheme();
    const properDarkTheme = useProperDarkTheme();

    if (!children) return null;

    if (theme === 'inherit') {
        return <>{children}</>;
    } else if (theme === 'light') {
        return <UeThemeProvider theme={properLightTheme}>{children}</UeThemeProvider>;
    } else {
        return <UeThemeProvider theme={properDarkTheme}>{children}</UeThemeProvider>;
    }
};
